import {useEffect, useState} from 'react';
import {createStyles, Grid, IconButton, makeStyles, useMediaQuery, useTheme, withStyles} from '@material-ui/core';
import ReelsBuilderSidebar from '../../../atoms/creator/reelsBuilderSidebar';
import {useDispatch, useSelector} from "react-redux";
import {apiClient} from '../../../../config/apiClient';
import PreReelSessions from "./reels/reelSessions";
import PreReelName from "./reels/reelName";
import ReelSchedule from "./reels/schedule";
import ReelReview from "./reels/review";
import ReelFinish from "./reels/finish";
import CreatorCloseBtnModal from '../../../atoms/modals/creatorCloseBtnModal';
import {
  emptyUserMetrics,
  experienceCategories,
  moveNextPage,
  updateUserMetrics,
  validateSessionCode
} from '../../../../store/actions/creator/creatorExperienceBuilder';
import {Helmet} from "react-helmet";
import {useHistory} from "react-router";
import {getExperiencesTotal} from '../../../../store/actions/experience/experience';
import {getConfigurationDetails} from "../../../../store/actions/index";
import {BackDropAnalyzeLoading} from "../../../atoms/commonLoadings";
import AnalyzeMobileSection from '../../../atoms/creator/analyzeMobileSection';
import clsx from 'clsx';
import ParticipantLists from "../../participant/list/IndexPage";
import ReelsInviting from "./reels/reelsInviting";

const styles = () =>
  createStyles({
    closeButton: {
      position: 'absolute',
      right: 40,
      top: 30,
    }
});
const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    overflow: 'auto'
  },
  h100: {
    height: '100%',
  },
  container: {
    flex: 1,
    marginTop: 30,
    paddingLeft: 20,
    paddingRight: 20,
    textAlign: 'left'
  },
  left: {
    width: 240,
  },
  closeBtn: {
    position: 'absolute',
    right: 40,
    top: 30,
    '&:hover': {
      cursor: 'pointer',
      background: "#f0f0f0",
      border: "1px solid #d9d9d9",
      padding: "3px 1px 0px 1px",
      borderRadius: 3
    }
  },
  dialog: {
    borderRadius: '24px!important'
  },
  modalBtn: {
    width: 80,
    height: 36,
    fontFamily: 'roboto-regular',
    textTransform: 'none',
    fontSize: 16,
    marginLeft: 14,
  },
  header: {
    color: '#606B76',
    fontFamily: 'Spartan-bold',
    fontSize: 24,
    paddingLeft: 17,
    paddingBottom: 7,
    margin:0
  },
  delemaildesc: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#697683'
  },
  tagmodalwrap: {
    margin: 'auto',
    maxWidth: 500,
    borderRadius: 14,
  },
  alignCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  }
}));

function ReelsBuilder(props: any) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { page, categories, userMetrics } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { addParticipantList } = userMetrics;
  const [modal, setModal] = useState(false);
  const { selected, onRemove, onCloseReelModel } = props;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const [fieldChanged,setFieldChange] = useState(true);
  const [confirmationLeavePage,setConfirmationLeavePage] = useState(false);
  const { totalExperienceCount } = useSelector((state: any) => state.experience);
  const [displayCloseBtn,setDisplayCloseBtn] = useState(true);
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down('xs'));

  const onRemoveReelSession = (item: any) => {
    if (selected && selected.length > 2) {
      onRemove(item);
    } else {
      clickCloseIcon();
    }
  };

  useEffect(() => {
    dispatch(experienceCategories(apolloClient.client));
    dispatch(getExperiencesTotal(apolloClient.client,{user_id:loginUserData.user_id}));
    const req = {
      "tenant_id": loginUserData.customer_id
    };
    dispatch(getConfigurationDetails(apolloClient.client,req))   
  },[apolloClient.client]);

  useEffect(() => {
    const getSessionCode = async () => {
      const payload = {
        "requestor": "experience",
        "tenant_id": loginUserData.customer_id
      };
      const res = await apiClient(false).post('/registration/v2/session/tokens', payload);
      if (res && res.data && res.data.token) {
        const checkSession = await validateSessionCode(apolloClient.client, res.data.token);
        if (checkSession && checkSession.data && checkSession.data.validateSessionCode) {
          localStorage.setItem("session_code", String(res.data.token));
          dispatch(updateUserMetrics('sessionCode', res.data.token));
          dispatch(updateUserMetrics('selectedSessions', selected));
        } else {
          getSessionCode();
        }
      } else {
        getSessionCode();
      } 
    };
    if (!loginUserData.session_Code) {
      getSessionCode();
    }
  },[ dispatch, loginUserData.customer_id, apolloClient]);

  useEffect(() => {
    if (totalExperienceCount !== null) {
      totalExperienceCount === 0 ? setDisplayCloseBtn(false) : setDisplayCloseBtn(true);
    }
  },[totalExperienceCount]);
  
  useEffect(() => {
    if (!fieldChanged) {
     history.push(`${confirmationLeavePage}`);
     dispatch(emptyUserMetrics());
     dispatch(moveNextPage(0));
     setConfirmationLeavePage(false)
    }
  }, [fieldChanged]);
  
  useEffect(() => {
    window.addEventListener('click', winsoPOP);
    return () => {
      window.removeEventListener('click', winsoPOP);
    };
  });
  
  const winsoPOP = (e:any) => {   
    const data=e.path;
    if (!data)  return;
    data.map((val: any) => {
      if (val.id==="id_/creator/dashboard") {
        history.push('/dashboardUrl');
        dispatch(moveNextPage(page+1))
      } 
    })   
  };

  const clickCloseIcon = () => {
    setModal(true);
  };

  const handleClose = () => {
    dispatch(moveNextPage(0));
    setModal(false);
    setConfirmationLeavePage(false);
  };

  const closeReelModel = () => {
    dispatch(emptyUserMetrics());
    setConfirmationLeavePage(false);
    handleClose();
    onCloseReelModel();
  };

  const ButtonClose = withStyles(styles)((props: any) => {
    const {classes} = props;
    return (
      <IconButton aria-label="close" className={classes.closeButton} onClick={clickCloseIcon}>
        <img src={'/assets/icons/experiencebuilder/close-icon.svg'} alt={'img'}/>
      </IconButton>
    );
  });
  
  return (
    <>
      {addParticipantList ? (
        <ParticipantLists />
      ) : (
        <div className={clsx(classes.root, !isMobileDevice && classes.h100)}>
          <Helmet title="Reels Builder"/>
          <BackDropAnalyzeLoading loading={!categories} />
          {
            isMobileDevice && <AnalyzeMobileSection page={true}/>
          }
          {!isMobileDevice && <div className={classes.left}>
            <ReelsBuilderSidebar />
          </div>}
          {displayCloseBtn && (
            <ButtonClose />
          )}

          {!isMobileDevice && <Grid container justifyContent={'center'} className={classes.container+" reels_builder_steps"} >
            {page === 0 && <Grid item lg={8} md={10} sm={12}><PreReelSessions selected={selected} onRemove={(item:any)=>onRemoveReelSession(item)} clickCloseIcon={() => clickCloseIcon()} /></Grid>}
            {page === 1 && <Grid item lg={8} md={10} sm={12}><PreReelName selected={selected} onRemove={(item:any)=>onRemoveReelSession(item)} clickCloseIcon={() => clickCloseIcon()}  /></Grid>}
            {page === 2 && <Grid item lg={8} md={10} sm={12}><ReelSchedule /></Grid>}
            {page === 3 &&
            <Grid className={classes.alignCenter} item lg={10} md={10} sm={12}><ReelsInviting /></Grid>}
            {page === 4 && <Grid item lg={9} md={10} sm={12}><ReelReview  selected={selected} onRemove={(item:any)=>onRemoveReelSession(item)}  /></Grid>}
            {page === 5 && <Grid item lg={8} md={10} sm={12}>
              <ReelFinish
                setConfirmationLeavePage={setConfirmationLeavePage}
                setFieldChange={setFieldChange}
              />
            </Grid>}
          </Grid>}

          <CreatorCloseBtnModal
            open={modal || !!confirmationLeavePage}
            onClose={handleClose}
            onApply={closeReelModel}
          />
        </div>
      )}
    </>
  )
}

export default ReelsBuilder;